module.exports = __webpack_public_path__ + "img/ico_error_push.319c6022.svg";